/** Solid line + pill label styling — mirrors TradingView “My Entries” indicator layout. */

/** Active heatmap windows (point-engine no longer collects 72h). */
export const TF_ORDER = ['48h', '24h', '12h']

/** Per-timeframe colors (short above ref, long below — same hue family as TV screenshot). */
export const LIQUIDITY_COLORS = {
  short: {
    '48h': '#7f1d1d',
    '24h': '#ea580c',
    '12h': '#fb923c',
    // Stale rows only — not in TF_ORDER.
    '72h': '#450a0a',
  },
  long: {
    '48h': '#14532d',
    '24h': '#15803d',
    '12h': '#4ade80',
    '72h': '#052e16',
  },
}

export const LIQUIDITY_LINE_WIDTH = {
  '48h': 2,
  '24h': 2,
  '12h': 2,
  '72h': 2,
}

/**
 * Compact price for on-chart pills (e.g. 79530.1 — no thousands separator).
 *
 * @param {number} value
 */
export function compactLevelPrice(value) {
  const abs = Math.abs(value)
  if (abs >= 1000) return value.toFixed(1)
  if (abs >= 1) return value.toFixed(2)
  return value.toFixed(4)
}

/**
 * Pill text: "48h 79530.1"
 *
 * @param {string} timeframe
 * @param {number} price
 */
export function levelPillText(timeframe, price) {
  return `${timeframe} ${compactLevelPrice(price)}`
}

/**
 * @param {'long' | 'short'} side
 * @param {string} timeframe
 */
export function levelColor(side, timeframe) {
  return LIQUIDITY_COLORS[side]?.[timeframe] ?? (side === 'short' ? '#ef4444' : '#22c55e')
}

/**
 * @param {string} timeframe
 */
export function levelLineWidth(timeframe) {
  const w = LIQUIDITY_LINE_WIDTH[timeframe] ?? 2
  return w
}
